import { defineConfig } from "../config";
import { authHeader } from "../helpers";
import { utilsService } from "./utils";
const { handleResponse } = utilsService;

export const OTPService = {
  sendOTP,
  checkOTP,
};

const { apiUrl, apiVer } = defineConfig.OTP_SERVICE;

function getApiPath() {
  return (apiUrl + apiVer + "/otp");
}

function sendOTP(email = "", name = "") {
  const MOCKEMAIL = "it@codesour.com";

  const url = getApiPath() + "/create";

  const values = {
    email: MOCKEMAIL,
    name: name
  }

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(values)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function checkOTP(otp, email) {
  const MOCKEMAIL = "it@codesour.com";

  const url = getApiPath() + "/read/check?otp=" + otp + "&email=" + MOCKEMAIL;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}